(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["germania-color-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('germania-color-preview')) {
    customElements.define('germania-color-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.updatePreview) return;
        this.productForm = this.closest('form');
        const data = this.querySelector('script[type="application/json"]');
        if (!this.productForm || !data) return;
        this.variants = JSON.parse(data.textContent);
        this.updatePreview = () => {
          const options = Array.from(this.productForm.querySelectorAll('.js-variant-selector')).map(select => select.value);
          const colorIndex = Number(this.dataset.optionIndex);
          const rawColor = options[colorIndex];
          const color = /^(moca|mocha|mcoha)$/i.test(rawColor || '') ? 'Mocha' : rawColor;
          if (!color) return;
          const exact = this.variants.find(variant => variant.options.every((value,index) => value === options[index]));
          const sameColor = this.variants.find(variant => variant.options[colorIndex] === rawColor && variant.image);
          const variant = exact && exact.image ? exact : sameColor;
          const image = this.querySelector('img');
          const status = this.querySelector('[role="status"]');
          if (variant && variant.image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
            image.alt = variant.alt + ' — ' + color;
            image.hidden = false;
            status.textContent = this.dataset.optionName + ': ' + color;
            status.classList.add('visually-hidden');
          } else {
            image.hidden = true;
            image.removeAttribute('src');
            image.removeAttribute('srcset');
            status.textContent = color + ' · ' + this.dataset.missingLabel;
            status.classList.remove('visually-hidden');
          }
        };
        this.productForm.addEventListener('change',this.updatePreview);
        this.updatePreview();
      }
      disconnectedCallback() {
        if (this.productForm && this.updatePreview) {
          this.productForm.removeEventListener('change',this.updatePreview);
          this.updatePreview = null;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["germania-product-choices"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('germania-product-choices')) {
    customElements.define('germania-product-choices', class extends HTMLElement {
      connectedCallback() {
        if (this.syncChoices) return;
        const data = this.querySelector('[data-choice-variants]');
        if (!data) return;
        this.variants = JSON.parse(data.textContent);
        this.selectors = Array.from(this.querySelectorAll('.js-variant-selector'));
        const optionContainer = this.querySelector('.product__variants-select');
        const groups = Array.from(optionContainer.children).filter(node => node.classList.contains('germania-choice-option')).map(group => {
          const index = Number(group.querySelector('[data-choice-index]').dataset.choiceIndex);
          const helper = group.nextElementSibling && group.nextElementSibling.classList.contains('germania-size-help') ? group.nextElementSibling : null;
          const color = group.querySelector('[data-color-option]').dataset.colorOption === 'true';
          return {group,index,helper,priority:color ? 0 : /size|talla|tamaño/i.test(this.selectors[index].name) ? 1 : 2};
        }).sort((a,b) => a.priority - b.priority || a.index - b.index);
        if (!this.querySelector('[data-native-options]')) {
          const nativeOptions = document.createElement('div');
          nativeOptions.hidden = true;
          nativeOptions.setAttribute('data-native-options','');
          this.selectors.forEach(select => nativeOptions.append(select.parentElement));
          optionContainer.prepend(nativeOptions);
          groups.forEach(({group,helper}) => {
            optionContainer.append(group);
            if (helper) optionContainer.append(helper);
          });
        }
        this.optionDisplayOrder = groups.map(group => group.index);
        const colorLabels = JSON.parse(this.querySelector('[data-choice-color-labels]').textContent);
        this.querySelectorAll('[data-color-option]').forEach(group => {
          const buttons = Array.from(group.querySelectorAll('[data-choice-value]'));
          const names = buttons.map(button => group.dataset.colorOption === 'true' ? colorLabels[button.dataset.choiceValue.toLowerCase().trim()] || button.dataset.choiceValue : button.dataset.choiceValue);
          buttons.forEach((button,index) => {
            const duplicate = names.filter(name => name.toLowerCase() === names[index].toLowerCase()).length > 1;
            button.dataset.choiceLabel = duplicate ? button.dataset.choiceValue : names[index];
            button.querySelector('span').textContent = button.dataset.choiceLabel;
          });
        });
        this.syncChoices = () => {
          const options = this.selectors.map(select => select.value);
          this.querySelectorAll('[data-choice-index]').forEach(button => {
            const index = Number(button.dataset.choiceIndex);
            const value = button.dataset.choiceValue;
            const isColor = button.closest('[data-color-option]').dataset.colorOption === 'true';
            const available = this.variants.some(variant => variant.available && variant.options[index] === value && options.every((option,i) => i === index || (isColor && /size|talla|tamaño/i.test(this.selectors[i].name)) || option === variant.options[i]));
            button.setAttribute('aria-pressed',String(options[index] === value));
            button.classList.toggle('is-sold-out',!available);
            button.querySelector('small').hidden = available;
            button.setAttribute('aria-label',button.dataset.choiceLabel + (available ? '' : ' — ' + this.dataset.soldOut));
          });
          const summary = this.closest('.product__section').querySelector('[data-germania-selection]');
          if (summary) {
            const selected = this.variants.find(variant => variant.options.every((value,i) => value === options[i]));
            const labels = this.selectors.map((select,i) => {
              const button = Array.from(this.querySelectorAll('[data-choice-index]')).find(button => Number(button.dataset.choiceIndex) === i && button.dataset.choiceValue === options[i]);
              return select.labels[0].textContent.trim() + ': ' + (button ? button.dataset.choiceLabel : options[i]);
            });
            summary.textContent = summary.dataset.label + ': ' + this.optionDisplayOrder.map(index => labels[index]).join(' · ') + (selected && selected.available ? '' : ' — ' + (this.hasAttribute('data-availability-trial') ? (this.variants.some(variant => variant.available) ? this.dataset.selectionUnavailable : this.dataset.productUnavailable) : this.dataset.soldOut));
          }
          if (this.hasAttribute('data-availability-trial')) {
            const sizeIndex = this.selectors.findIndex(select => /size|talla|tamaño/i.test(select.name));
            const availableSizes = sizeIndex < 0 ? [] : this.variants.filter(variant => variant.available && options.every((value,index) => index === sizeIndex || variant.options[index] === value)).map(variant => variant.options[sizeIndex]);
            const selected = this.variants.find(variant => variant.options.every((value,index) => value === options[index]));
            const anyAvailable = this.variants.some(variant => variant.available);
            const message = !anyAvailable ? this.dataset.productUnavailable : selected && selected.available ? '' : this.dataset.selectionUnavailable;
            const sizes = sizeIndex < 0 ? '' : availableSizes.length ? this.dataset.sizesLabel + ': ' + [...new Set(availableSizes)].join(', ') : this.dataset.noSizes;
            this.querySelector('[data-availability-status]').textContent = [message,sizes].filter(Boolean).join(' ');
          }
        };
        this.chooseOption = event => {
          const button = event.target.closest('[data-choice-index]');
          if (!button || !this.contains(button)) return;
          const select = this.selectors[Number(button.dataset.choiceIndex)];
          select.value = button.dataset.choiceValue;
          select.dispatchEvent(new Event('change',{bubbles:true}));
        };
        this.addEventListener('click',this.chooseOption);
        this.addEventListener('change',this.syncChoices);
        this.selectors.forEach(select => {
          select.tabIndex = -1;
          select.parentElement.setAttribute('aria-hidden','true');
        });
        this.setAttribute('data-ready','');
        this.syncChoices();
      }
      disconnectedCallback() {
        if (!this.syncChoices) return;
        this.removeEventListener('click',this.chooseOption);
        this.removeEventListener('change',this.syncChoices);
        this.syncChoices = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
